import { styledOptions } from "../../../utils/styled-options/styled-options.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
import { Border } from "../../../foundations/palette.es.js";
import { theme } from "../../../foundations/theme.es.js";
import { BorderStyle } from "../../../foundations/border-style.es.js";
import { CursorStyle } from "../../../foundations/cursor-style.es.js";
import styled from "../../../../node_modules/@mui/material/styles/styled.es.js";
import MuiCard from "../../../../node_modules/@mui/material/Card/Card.es.js";
const BORDER_THICKNESS = "0.063rem";
const SearchCardContainer = styled(MuiCard, styledOptions)(({
  accentColor
}) => {
  return {
    padding: `${Spacing[750]} ${Spacing[1e3]}`,
    borderRadius: Spacing[500],
    border: `${BORDER_THICKNESS} ${BorderStyle.solid} ${Border.main}`,
    borderLeft: `${Spacing[500]} solid ${theme.palette[accentColor].main}`,
    "&:hover": {
      cursor: CursorStyle.pointer,
      border: `${BORDER_THICKNESS} ${BorderStyle.solid} ${Border.dark}`,
      borderLeft: `${Spacing[500]} solid ${theme.palette[accentColor].main}`
    }
  };
});
export {
  SearchCardContainer
};
//# sourceMappingURL=SearchCardContainer.es.js.map
